import { createSlice } from "@reduxjs/toolkit";
import unescape from "lodash/unescape";
import environment from "web/script/modules/environment";
var initialValues = environment.get("showPreviousButton");
var initialState = {
  buttonUrl: null,
  isLoading: false
};

if (initialValues) {
  initialState.buttonUrl = unescape(initialValues.previous_url);
}

var feedsShowPrevious = createSlice({
  name: "feedsShowPrevious",
  initialState: initialState,
  reducers: {
    setButtonUrl: function setButtonUrl(state, action) {
      state.buttonUrl = action.payload;
    },
    setLoading: function setLoading(state, action) {
      state.isLoading = action.payload;
    }
  }
});
var actions = feedsShowPrevious.actions,
    reducer = feedsShowPrevious.reducer;
var setButtonUrl = actions.setButtonUrl,
    setLoading = actions.setLoading;
export { setButtonUrl, setLoading };
export default reducer;